import { modifyPageLayoutComponents } from '../PageLayout';
import { FeatureInclusion, FeatureInclusionHeader, FeatureInclusionSubHeader } from './featureInclusion';

export const FeatureInclusionComponents = modifyPageLayoutComponents({
  pageHeader: FeatureInclusionHeader,
  pageMenu: FeatureInclusionSubHeader,
  content: FeatureInclusion
});
